import "alpinejs";

window.videoSwitcheroo = function() {
    return {
        currentVideo: "ct",
        changeVideo(video) {
            this.currentVideo = video;

            document.querySelector("#hero-video").scrollIntoView({
                behavior: "smooth"
            });
        }
    };
};

window.scrollManager = function() {
    return {
        menuOpen: false,
        scrollTo(id) {
            document.querySelector("#" + id).scrollIntoView({
                behavior: "smooth"
            });
        }
    };
};
